import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';

import { useUserContext } from './context/UserContext';
import SignIn from './pages/auth/SignIn';
import ResetPassword from './pages/auth/ResetPassword';
import Buildings from './pages/dashboard/Buildings';
import BuildingEntity from './pages/dashboard/BuildingEntity';
import MyApartments from './pages/dashboard/MyProperties';
import ApartmentAdministration from './pages/apartment/ApartmentAdministration';
import { LanguageProvider } from './context/LanguageContext';
import Layout from './components/layout/Layout';
import RequireAuth from './components/auth/RequireAuth';

function App() {
    const { token } = useUserContext();

    // Set axios base URL once
    axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://hedgeiot.epu.ntua.gr/api';

    // Set Authorization synchronously so it's on axios before any child useEffect runs (avoids 401 from early requests)
    if (token) {
        axios.defaults.headers.common['Authorization'] = `${token}`;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }

    // Keep header in sync when token changes (login/logout)
    useEffect(() => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `${token}`;
        } else {
            delete axios.defaults.headers.common['Authorization'];
        }
    }, [token]);

    // On 401 when we had a token set: clear auth and force redirect to signin (avoids relying on React state/events)
    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (res) => res,
            (err) => {
                if (err.response?.status === 401) {
                    const tokenWasSet = !!axios.defaults.headers?.common?.Authorization;
                    if (tokenWasSet) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('username');
                        delete axios.defaults.headers.common['Authorization'];
                        window.location.href = '/signin';
                    }
                }
                return Promise.reject(err);
            }
        );
        return () => axios.interceptors.response.eject(interceptor);
    }, []);

    return (
        <Router>
            <LanguageProvider>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<RequireAuth><MyApartments /></RequireAuth>} />
                        {/* <Route path="building/:id" element={<RequireAuth><BuildingEntity /></RequireAuth>} /> */}
                        <Route path="my-apartments" element={<RequireAuth><MyApartments /></RequireAuth>} />
                        {/* <Route path="building/:buildingId/apartment/:id" element={<RequireAuth><ApartmentAdministration /></RequireAuth>} /> */}
                        <Route path="signin" element={<SignIn />} />
                        <Route path="reset-password" element={<ResetPassword />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </LanguageProvider>
        </Router>
    );
}

export default App;
